export default __webpack_public_path__ + "static/media/cadre_mentorship_code_of_conduct.247f92ff.pdf";